import React, { useEffect, useState } from "react";
import { BsPlusCircle } from "react-icons/bs";
import { MultiSelect } from "react-multi-select-component";
import axios from "../../../../axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CommunityPopup from "./CommunityPopup";
import { IP } from "./../../../../internalServer";
import { toast } from "react-toastify";
import assets from "../../../../assets/assets";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Underline } from "lucide-react";
import { X } from 'lucide-react';

export default function AddMemebers({
  communityDetails,
  setOpenSuccessfull,
  setChannel,
  items,
  setInAddingMode,
  isAddingModel,
  community,
  isAboutPage,
  setSelectedListStudentClassStateParent,
  selectedStudentListClassStateParent,
  stdParent,
  setStdParent,
  secParent,
  setSecParent,
  setSuccessMsg,
  teachers,
  students,
}) {
  const [addedMemebers, setAddedMembers] = useState(community?.members);

  const allStudentList = useSelector(
    (state) => state.initialData.getAllStudentList
  );
  const allTeacherList = useSelector(
    (state) => state.initialData.getAllTeacherList
  );

  const { state } = useLocation();
  const [addMember, setAddMember] = useState({
    activeMember: "Teacher",
    addTeacher: false,
    addGroups: false,
    addStudent: false,
  });
  const [clicked, setClicked] = useState(false);
  const [added, setAdded] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedStuOptions, setSelectedStuOptions] = useState([]);
  const [sectionDef, setSectionDef] = useState([]);
  const [displyaData, setDisplayData] = useState([]);
  const [displayTeacherData, setDisplayTeacherData] = useState([]);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showPopUp, setShowPopUp] = useState(false);

  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  let school_id = JSON.parse(localStorage.getItem("schoolId"));
  const [inProgress, setInProgress] = useState(false);
  const [multiSelectKey, setMultiSelectKey] = useState(0);
  const [isValid, setIsValid] = useState(true);
  const [persistentSelectedStudents, setPersistentSelectedStudents] = useState(
    []
  );
  const [selectedStudentListGroupsState, setSelectedListStudentGroupState] =
    useState([]);
  const [studentSectionOptionsState, setStudentSectionOptionsState] =
    useState(null);
  const [selectedStudentListClassState, setSelectedListStudentClassState] =
    useState(selectedStudentListClassStateParent || []);
  const [optionStudentGroupsState, setOptionStudentGroupsState] =
    useState(null);
  const [studentClassOptionState, setStudentClassOptionState] = useState(null);

  const [teacherList, setTeacherList] = useState([]);

  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON = JSON.parse(general_role);

  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON = JSON.parse(classTeacher);

  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON = JSON.parse(cordinator);

  const [groupList, setGroupList] = useState([
    {
      label: "Select All",
      value: null,
    },
  ]);
  const [groupListForStudent, setGroupListForStudent] = useState([]);
  const [studentListByGroup, setStudentListByGroup] = useState([]);
  const [standardDetails, setStandardDetails] = useState({
    standardList: [], // List of classes/standards
    sectionList: [], // List of sections
    studentList: [], // List of students
  });

  const [filter, setFilter] = useState({
    standard_id: "",
    section_id: "",
  });

  useEffect(() => {
    try {
      const getTeachers = async () => {
        const teacherResponse = await axios.get(
          `/api/v1/school/teacher/get/school/${school_id}`
        );
        // setAllTeacherList(teacherResponse?.data?.data)
        if (allTeacherList || teacherResponse?.data?.data) {
          const existingAdminsIds =
            addedMemebers?.find((member) => member.admins_id)?.admins_id || [];
          const existingTeachersIds =
            addedMemebers?.find((member) => member.teachers_id)?.teachers_id ||
            [];
          const teachers = (
            allTeacherList?.length > 0
              ? allTeacherList
              : teacherResponse?.data?.data
          )
            .filter(
              (item) =>
                item.id !== teacher_id && // Exclude the teacher with specific teacher_id
                !existingAdminsIds.includes(item.id) &&
                !existingTeachersIds.includes(item.id)
            )
            .map((item, index) => {
              return {
                label: item.name + " | Code: " + item.code,
                value: item.id,
                code: item.code,
                gender: item.gender,
                profilePicture: item.profile_picture,
                memberType: "member",
              };
            });
          setTeacherList([...teacherList, ...teachers]);
        }
      };
      //
      getTeachers();
    } catch (error) {
      console.log("error", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj)
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id)
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id)
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };
  dropDownHelper();

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  const getGroupList = async () => {
    let res = await axios.get(
      `/api/v1/group/filterForTeacher/teacherId/${teacher_id}?type=Community&_page=1&_limit=20`
    );
    if (res) {
      const groups = res.data.data.map((item, index) => ({
        label: item.name,
        value: item.id,
      }));
      // Convert the groupList to a Set to filter out duplicates
      const uniqueGroups = new Set([
        ...groupList.map(JSON.stringify),
        ...groups.map(JSON.stringify),
      ]);
      const updatedGroupList = Array.from(uniqueGroups).map(JSON.parse);
      setGroupList(updatedGroupList);
    }
  };
  const getGroupListForStudent = async () => {
    let res = await axios.get(
      `/api/v1/group/filterForTeacher/teacherId/${teacher_id}?type=Community&_page=1&_limit=20`
    );
    if (res) {
      const groups = res.data.data.map((item, index) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setGroupListForStudent(groups);
    }
  };

  const handleGroupSelection = async (selectedOption) => {
    setOptionStudentGroupsState(selectedOption);
    try {
      let res = await axios.get(
        `/api/v1/group/getById/${selectedOption.value}?isFullFledged=true`
      );
      if (res) {
        // const existingStudentsIds =
        //   addedMemebers.find((member) => member.students_id)?.students_id || [];

        const students = res?.data?.data?.member
          .filter((item) => item.member_type === "Student")
          .map((item) => {
            return {
              label: item.member.name,
              value: item.member.id,
            };
          });
        setStudentListByGroup(students);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Hide the code for get standard and section based on role

  // const CTRole_Information = JSON.parse(
  //   localStorage.getItem("role_as_class_teacher")
  // );
  // const CoRole_Information = JSON.parse(
  //   localStorage.getItem("role_as_co_ordinator")
  // );
  // const general_role = JSON.parse(localStorage.getItem("general_role"));

  // useEffect(() => {
  //   if (CTRole_Information && CTRole_Information?.length > 0) {
  //     CTRole_Information?.forEach((obj) => {
  //       if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //         standardList.push(obj.standard_id);
  //       }
  //       if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //         sectionList.push(obj.section_id);
  //       }
  //     });
  //   }
  //   if (CoRole_Information && CoRole_Information?.length > 0) {
  //     CoRole_Information?.forEach((obj) => {
  //       if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //         standardList.push(obj.standard_id);
  //       }
  //       if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //         sectionList.push(obj.section_id);
  //       }
  //     });
  //   }
  //   if (general_role && general_role?.length > 0) {
  //     general_role?.forEach((obj) => {
  //       if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //         standardList.push(obj.standard_id);
  //       }
  //       if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //         sectionList.push(obj.section_id);
  //       }
  //     });
  //   }
  //   if (standardList) {
  //     standardList?.length > 0 &&
  //       setStandardDetails({
  //         ...standardDetails,
  //         standardList,
  //       });
  //   }

  //   if (sectionList && sectionList?.length > 0) {
  //     setStandardDetails({
  //       ...standardDetails,
  //       sectionList,
  //     });
  //     setSectionDef(sectionList);
  //   }
  // }, []);
  useEffect(() => {
    async function fetchDropDowns() {
      //Here added api for get student list for display more info on UI
      if (filter.standard_id || filter.section_id) {
        try {
          const response = await axios.get(
            `/api/v1/school/student/get/school/${school_id}`
          );
          if (allStudentList || response) {
            const existingStudentsIds =
              addedMemebers?.find((member) => member.students_id)
                ?.students_id || [];
            const students = response?.data?.data
              ?.filter(
                (item) =>
                  item.section.id === filter.section_id &&
                  item.standard.id === filter.standard_id &&
                  !existingStudentsIds.includes(item.id) // Exclude already added students
              )
              .map((item) => {
                return {
                  label: item.name + " | Code: " + item.code,
                  displayLevel: item.name,
                  value: item.id,
                  code: item.code,
                  section: item.section.name,
                  standard: item.standard.name,
                };
              });
            setStandardDetails({
              ...standardDetails,
              studentList: students,
            });
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    }
    fetchDropDowns();
  }, [filter.standard_id, filter.section_id]);

  // This method is written above

  const getStudentListByStandardAndSection = async (selectedOption) => {
    setStudentSectionOptionsState(selectedOption);
    setSecParent(selectedOption);
    try {
      if (filter.standard_id || filter.section_id) {
        const response = await axios.get(
          `/api/v1/school/student/get/school/${school_id}`
        );
        if (allStudentList || response) {
          const existingStudentsIds =
            addedMemebers?.map((member) => member.students_id) || [];
          const students = (response?.data?.data)
            .filter(
              (item) =>
                item.section.id === filter.standard_id &&
                item.standard.id === filter.section_id &&
                !existingStudentsIds.includes(item.id) // Exclude already added students
            )
            .map((item) => {
              return {
                label: item.name + "Code: " + item.code,
                displayLevel: item.name,
                value: item.id,
                code: item.code,
                section: item.section.name,
                standard: item.standard.name,
              };
            });
          setStandardDetails({
            ...standardDetails,
            studentList: students,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleStudentOptionChange = (selectedOption) => {
    // Add memberType to each selected item
    const updated = selectedOption.map((i) => ({
      ...i,
      memberType: selectedClass.value,
    }));

    setSelectedListStudentClassState((prev) => {
      const merged = [
        ...prev,
        ...updated.filter((u) => !prev.some((p) => p.value === u.value)),
      ];

      // Save to localStorage
      localStorage.setItem(
        "STUDENT_OPTIONS_STORAGE_KEY",
        JSON.stringify(merged)
      );

      return merged;
    });
  };

  const handleUnselectStudent = (id) => {

    const updatedList = selectedStudentListClassState.filter(
      (item) => item.value !== id
    );

    setSelectedListStudentClassState(updatedList);

    // update localStorage also if needed
    localStorage.setItem(
      "STUDENT_OPTIONS_STORAGE_KEY",
      JSON.stringify(updatedList)
    );
  };



  const handleAddMember = () => {
    switch (addMember.activeMember) {
      case "Teacher":
        if (selectedOptions?.length > 0 && added) {
          setAddMember({ ...addMember, addTeacher: true });
        }
        break;
      case "Group":
        selectedOptionsGoups?.length > 0 &&
          setAddMember({ ...addMember, addGroups: true });
        break;
      case "Student":
        (selectedStudentListGroupsState?.length > 0 ||
          selectedStudentListClassState?.length > 0) &&
          setAddMember({ ...addMember, addStudent: true });
        break;
      default:
        // do nothing
        break;
    }
  };

  const DropdownStyle = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#99ADBB",
      height: "34px",
      width: "127px",
      borderRadius: " 5px",
      fontSize: "12px",
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: state.selectProps.menuWidth || "auto", // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  // serch dropdown
  const SearchDropdownStyle = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      border: "none",
      width: "35vw",
      borderRadius: " 5px",
      fontSize: "16px",
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "35vw",
      padding: "10px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      color: "#F77F00", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        marginRight: "10px",
      },
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: "none",
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  // code for teahcer
  const ClassOptions = [
    { value: "admin", label: "Admin" },
    { value: "moderator", label: "Moderator" },
    { value: "member", label: "Member" },
  ];
  const [selectedClass, setSelectedClass] = useState({
    value: "member",
    label: "Member",
  });

  const Option = (props) => {
    const { data, isSelected, innerRef, selectProps } = props;

    let isChecked = isSelected;
    if (data.value === null) {
      isChecked = selectProps.value?.length === teacherList?.length - 1;
    }

    return (
      <div
        ref={innerRef}
        className={`option ${isSelected ? "selected" : ""}`}
        onClick={() => props.selectOption(props.data)}
      >
        <input
          type="checkbox"
          checked={isChecked}
          readOnly
          style={{ marginRight: "8px" }}
        />
        <span style={{ color: "#000000", fontSize: "14px", cursor: "pointer" }}>
          {data.label}
        </span>
      </div>
    );
  };

  const handleOptionChange = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === null)) {
      setSelectedOptions(teacherList.slice(1));
    } else {
      for (let i of selectedOptions) {
        i.memberType = selectedClass.value;
      }
      setSelectedOptions(selectedOptions);
      localStorage.setItem(
        "TEACHER_OPTIONS_STORAGE_KEY",
        JSON.stringify(selectedOptions)
      );
    }
  };
  // useEffect(() => {
  //   const storedTeacherOptions = localStorage.getItem(
  //     "TEACHER_OPTIONS_STORAGE_KEY"
  //   );
  //   if (storedTeacherOptions) {
  //     let res = JSON.parse(storedTeacherOptions);
  //     if (res??.length > 0) {
  //       setAddMember({
  //         ...addMember,
  //         addTeacher: true,
  //       });
  //       setSelectedOptions(JSON.parse(storedTeacherOptions));
  //       // setAddMember({...addMember,addTeacher:true})
  //     }
  //   }
  // }, []);

  //Hide the code for header select box
  // const handelHeaderSelectOption = (selectedOption) => {
  //   setSelectedClass(selectedOption);
  //   for (let i of selectedOptions) {
  //     i.memberType = selectedOption.value;
  //   }
  //   setSelectedOptions(selectedOptions);
  // };

  //Update the logic for select member type
  const handelChangePurticularMemberType = (selectedOption, id) => {
    setSelectedOptions((prevOptions) => {
      const newOptions = prevOptions.map((option) => {
        if (option.value === id) {
          return { ...option, memberType: selectedOption.value };
        }
        return option;
      });

      const displayTeacherList = newOptions.map((val) => {
        return {
          label: val.label,
          value: val.value,
          code: val.code,
          memberType: val.memberType,
          profilePicture: val.profilePicture,
        };
      });

      setDisplayTeacherData(displayTeacherList);
      return newOptions;
    });
  };

  // this css for student class
  const DropdownStyleStudentsClass = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#99ADBB",
      height: "30px",
      width: "210px",

      borderRadius: " 5px",
      fontSize: "12px",
      // border: 'none',
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "200px", // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  // code for Groups
  const DropdownStyleStudents = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#99ADBB",
      height: "30px",
      width: "350px",
      borderRadius: " 5px",
      fontSize: "12px",
      // border: 'none',
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "305px", // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  const [selectedOptionsGoups, setSelectedOptionsGoups] = useState([]);

  const handleOptionChangeGroups = (selectedOptionsGoups) => {
    if (selectedOptionsGoups.some((option) => option.value === null)) {
      setSelectedOptionsGoups(groupList.slice(1));
    } else {
      setSelectedOptionsGoups(selectedOptionsGoups);
    }
  };

  useEffect(() => {
    if (
      selectedOptionsGoups?.length > 0 ||
      selectedStudentListClassState?.length > 0 ||
      selectedStudentListGroupsState?.length > 0 ||
      selectedOptions?.length > 0
    ) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedOptionsGoups,
    selectedStudentListClassState,
    selectedStudentListGroupsState,
    selectedOptions,
  ]);

  const handelSubmit = async (e) => {
    if (
      selectedOptions?.length === 0 &&
      selectedStudentListClassState?.length === 0
    ) {
      toast.error("Please add at least one member.");
      return;
    }
    setInProgress(true);
    setIsValid(true);
    let members = [];
    if (selectedOptionsGoups && selectedOptionsGoups?.length > 0) {
      let groups = selectedOptionsGoups.map((group) => {
        return group.value;
      });
      members.push({ groups: groups });
    }

    if (
      selectedStudentListClassState &&
      selectedStudentListClassState?.length > 0
    ) {
      let students = selectedStudentListClassState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    }
    if (
      selectedStudentListGroupsState &&
      selectedStudentListGroupsState?.length > 0
    ) {
      let students = selectedStudentListGroupsState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    }

    if (selectedOptions && selectedOptions?.length > 0) {
      let teachers = selectedOptions.map((teacher) => {
        return { id: teacher.value, role: teacher.memberType };
      });
      members.push({ teachers: teachers });
    }

    let newCommunity = {
      user_id: teacher_id,
      community_name: communityDetails.name,
      short_description: communityDetails.description,
      members,
    };

    if (communityDetails.profilePicture) {
      const formData = new FormData();
      formData.append("name", communityDetails.profilePicture.name);
      formData.append(
        "uploadCommunityAttachment",
        communityDetails.profilePicture
      );
      try {
        const res = await axios.post(
          `/api/v1/community/uploadAttachment/teacherId/${teacher_id}`,
          formData
        );
        newCommunity.profile_picture = res.data.data;
      } catch (error) { }
    }
    try {
      let res = await axios.post(`/api/v1/community/create`, newCommunity);
      if (res) {
        setInProgress(false);
        setSuccessMsg(res.data.message);
      }
      setOpenSuccessfull(true);
    } catch (error) {
      if (error) {
        setShowErrorMsg(error?.response?.data?.message);
        setShowPopUp(true);
        console.log(error);
      }
    } finally {
      setSelectedOptions([]);
      localStorage.removeItem("TEACHER_OPTIONS_STORAGE_KEY");
      setSelectedListStudentClassState([]);
    }
  };

  const handelAddMemberInExisting = async (e) => {
    setInProgress(true);
    setIsValid(true);
    let members = [];
    if (selectedOptionsGoups && selectedOptionsGoups?.length > 0) {
      let groups = selectedOptionsGoups.map((group) => {
        return group.value;
      });
      members.push({ groups: groups });
    }

    if (
      selectedStudentListClassState &&
      selectedStudentListClassState?.length > 0
    ) {
      let students = selectedStudentListClassState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    } else if (
      selectedStudentListGroupsState &&
      selectedStudentListGroupsState?.length > 0
    ) {
      let students = selectedStudentListGroupsState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    }
    if (selectedOptions && selectedOptions?.length > 0) {
      const existingTeacherIds = teachers.map((t) => t.teacher.id);

      const teachersToAdd = selectedOptions.filter(
        (teacher) => !existingTeacherIds.includes(teacher.value)
      );

      if (teachersToAdd.length > 0) {
        const newTeachers = teachersToAdd.map((teacher) => ({
          id: teacher.value,
          role: teacher.memberType,
        }));
        members.push({ teachers: newTeachers });
      } else {
        toast.error("Teacher is already added");
        return;
      }
    }

    console.log("members", members);
    console.log(teachers, "teachers");

    let newMembers = {
      user_id: teacher_id,
      members,
    };

    try {
      let res = await axios.post(
        `/api/v1/community/addMember/${state.communityId}`,
        newMembers
      );
      res && setInProgress(false);
      setOpenSuccessfull(true);
    } catch (error) {
      console.log("error test", error);
    } finally {
      const fromdiscard = "Discard";
      handleGoBack(fromdiscard);
      setSelectedOptions([]);
      localStorage.removeItem("TEACHER_OPTIONS_STORAGE_KEY");
      setSelectedListStudentClassState([]);
      setSelectedListStudentClassStateParent([]); // if you're syncing with parent
    }
  };

  // code for student radio butoons
  const [activeRadio, setActiveRadio] = useState("Groups");

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleGoBack = (fromdiscard) => {
    if (fromdiscard !== "Discard") {
      setChannel({
        addMembers: false,
      });
    }
    // setDisplayData([]);
    // setSelectedListStudentClassState([]);
    // setSelectedListStudentClassStateParent([]);
    setSecParent(null);
    setStdParent(null);
    // setSelectedOptions([]);
    // setMultiSelectKey((prev) => prev + 1);
    // localStorage.removeItem("TEACHER_OPTIONS_STORAGE_KEY");
    // localStorage.removeItem("STUDENT_OPTIONS_STORAGE_KEY");
  };

  console.log(selectedOptions, "selectedOptionsteachers");

  useEffect(() => {
    const storedTeachers = localStorage.getItem("TEACHER_OPTIONS_STORAGE_KEY");
    if (storedTeachers) {
      const parsed = JSON.parse(storedTeachers);
      if (Array.isArray(parsed) && parsed.length > 0) {
        setSelectedOptions(parsed);
      }
    }
  }, []);
  useEffect(() => {
    const storedStudents = localStorage.getItem("STUDENT_OPTIONS_STORAGE_KEY");
    if (storedStudents) {
      const parsed = JSON.parse(storedStudents);
      if (Array.isArray(parsed) && parsed.length > 0) {
        setSelectedListStudentClassState(parsed);
      }
    }
    return () => {
      localStorage.removeItem("STUDENT_OPTIONS_STORAGE_KEY");
    };
  }, []);

  // Filter logic (before rendering MultiSelect)
  const addedTeacherIds = teachers?.map((t) => t.teacher.id) || [];

  const filteredTeacherList = teacherList.filter(
    (teacher) => !addedTeacherIds.includes(teacher.value)
  );

  const addedStudents = students?.map((s) => s.student.id) || [];

  const filteredStudentList = standardDetails.studentList?.filter(
    (student) => !addedStudents.includes(student.value)
  );

  return (
    <>
      <div className="BigRelative">
        <div className="RelativeContainer">
          <div className="addMemberHeader mb-3 d-flex align-items-center justify-content-between gap-2">
            <span className="poppins-semibold">Add Members</span>
            {isAddingModel && (
              <button
                className="cursor-pointer border-0 bg-transparent"
                onClick={(e) => {
                  setInAddingMode(!isAddingModel);
                  const fromdiscard = "Discard";
                  handleGoBack(fromdiscard);
                }}
              >
                <img
                  src={assets.closeIcon}
                  alt="crossButton"
                  height={"20px"}
                  width={"20px"}
                />
              </button>
            )}
          </div>
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex gap-3 mt-2">
              <button
                onClick={(e) =>
                  setAddMember({ ...addMember, activeMember: "Teacher" })
                }
                className={` ${addMember.activeMember === "Teacher"
                  ? "active addMemberBtns_active"
                  : "addMemberBtns"
                  }`}
              >
                Teacher
              </button>
              <button
                onClick={(e) => {
                  setAddMember({ ...addMember, activeMember: "Student" });
                  getGroupListForStudent();
                }}
                className={` ${addMember.activeMember === "Student"
                  ? "active addMemberBtns_active"
                  : "addMemberBtns"
                  }`}
              >
                Student
              </button>
              {/* <button
              onClick={(e) => {
                setAddMember({ ...addMember, activeMember: "Group" });
                getGroupList();
              }}
              className={` ${addMember.activeMember === "Group"
                ? "active addMemberBtns_active"
                : "addMemberBtns"
                }`}
            >
              Groups / Classes
            </button> */}
            </div>

            {/* <div>
              <button
                onClick={() => {
                  handleAddMember();
                  // setAdded(true);
                  // setClicked(false);
                }}
                className="addMemberAddBtns"
              >
                <BsPlusCircle />
                &nbsp; Add
              </button>
            </div> */}
          </div>

          {addMember.activeMember === "Teacher" && (
            <div className="Container_bothDropdowns d-flex justify-content-between align-items-center mt-3">
              <div style={{ maxWidth: "300px", flex: 1 }}>
                <MultiSelect
                  options={teachers ? filteredTeacherList : teacherList}
                  value={selectedOptions}
                  onChange={(selectedOptions) => {
                    handleOptionChange(selectedOptions);
                    let displayTeacherList = selectedOptions.map((val) => {
                      return {
                        label: val.label,
                        value: val.value,
                        code: val.code,
                        gender: val.gender,
                        memberType: val.memberType,
                        profilePicture: val.profilePicture,
                      };
                    });
                    // Avoid duplicates in display data
                    setDisplayTeacherData((prev) => {
                      const combinedDisplayData = [...prev];
                      displayTeacherList.forEach((teacher) => {
                        if (
                          !combinedDisplayData.some(
                            (item) => item.value === teacher.value
                          )
                        ) {
                          combinedDisplayData.push(teacher);
                        }
                      });

                      // Remove students that have been unchecked (not in selectedOption)
                      const finalDisplayData = displayTeacherList.filter(
                        (teacher) =>
                          selectedOptions.some(
                            (selected) => selected.value === teacher.value
                          )
                      );

                      return finalDisplayData;
                    });

                    setClicked(true);
                  }}
                  isClearable
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={SearchDropdownStyle}
                  selected={true}
                  width={160}
                />
              </div>
            </div>
          )}

          {addMember.activeMember === "Student" && (
            <div className="mt-2">
              <div className="Container_bothDropdowns ">
                {
                  <div className="w-100 d-flex gap-3 flex-wrap">
                    {/* <div>
                      <Select
                        styles={DropdownStyleStudentsClass}
                        options={standardDetails.standardList}
                        value={stdParent} // Currently selected class
                        onChange={(selectedOption) => {
                          handelStandardSelectionOption(selectedOption);
                          setSecParent(null);
                        }} // Handle class selection
                        placeholder="Select Class"
                      />
                    </div> */}
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <InputLabel>Select Class</InputLabel>
                      <Select
                        label="Select Class"
                        value={filter.standard_id}
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            standard_id: e.target.value,
                            section_id: "",
                          })
                        }
                      >
                        <MenuItem value="">Select All</MenuItem>
                        {standardArr?.length > 0 &&
                          [...standardArr]
                            .sort((a, b) => {
                              const aNum = Number(a.name);
                              const bNum = Number(b.name);

                              const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                              if (bothNumeric) {
                                return aNum - bNum; // numeric sort
                              }

                              return a.name.localeCompare(b.name); // alphabetical sort
                            })
                            .map((standard, index) => (
                              <MenuItem
                                key={index}
                                value={standard?.id}
                                name={standard?.name}
                              >
                                {standard?.name}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>

                    {/* <div>
                      <Select
                        styles={DropdownStyleStudentsClass}
                        options={sectionDef} // Sections from API based on selected class
                        value={secParent} // Currently selected section
                        onChange={(selectedOption) => {
                          setSecParent(selectedOption); // Set selected section
                          getStudentListByStandardAndSection(selectedOption); // Fetch students based on section
                        }}
                        placeholder="Select Section"
                        menuWidth={127}
                      />
                    </div> */}

                    {/* Section Select */}
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <InputLabel>Select Section</InputLabel>
                      <Select
                        label="Select Section"
                        value={filter.section_id}
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            section_id: e.target.value,
                          })
                        }
                        disabled={!filter.standard_id} // Class select hone se pehle disable
                      >
                        <MenuItem value="">Select All</MenuItem>
                        {sectionArr &&
                          sectionArr.length > 0 &&
                          sectionArr
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((obj) => (
                              <MenuItem key={obj.id} value={obj.id}>
                                {obj.name}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>

                    <MultiSelect
                      key={multiSelectKey}
                      styles={DropdownStyleStudentsClass}
                      options={filteredStudentList}
                      value={selectedStudentListClassState}
                      onChange={(selectedOption) => {
                        handleStudentOptionChange(selectedOption);
                        setSelectedListStudentClassStateParent(selectedOption);
                        setClicked(true);
                      }}
                      className="custom-multiselectNew"
                      labelledBy={"Select"}
                      overrideStrings={{ selectSomeItems: "Select Students" }}
                    />
                  </div>
                }
              </div>
            </div>
          )}

          {!addMember.activeMember === "Group" && (
            <div className="Container_bothDropdowns d-flex justify-content-between align-items-center mt-3">
              <div style={{ maxWidth: "300px", flex: 1 }}>
                <Select
                  options={groupList}
                  value={selectedOptionsGoups}
                  onChange={handleOptionChangeGroups}
                  placeholder="Type here to search..."
                  isClearable
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={SearchDropdownStyle}
                />
              </div>
            </div>
          )}

          <div
            className="orange-scrollBar mt-3 p-2 rounded-sm"
            style={{
              height: "250px",
              backgroundColor: "#f8f8f8",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            {/* TEACHERS */}
            <div>
              <div className="">
                <div className="addedMember">
                  {selectedOptions?.length === 0 &&
                    selectedStudentListClassState?.length === 0
                    ? "Add Membrs"
                    : "Added Members"}
                </div>

                {selectedOptions?.length > 0 && (
                  <div className="teacher_header mt-2">TEACHERS</div>
                )}
                {console.log("selectedOptions", selectedOptions)}
                {selectedOptions?.map((item) => {
                  return (
                    <div className="d-flex">
                      <div
                        key={item.id}
                        className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                      >
                        <div className=" d-flex justify-content-center">
                          <div className="">
                            <img
                              src={
                                item?.profile_picture
                                  ? IP +
                                  item?.profile_picture.replace(/^\./, "")
                                  : item?.gender === "M"
                                    ? "/images/Teacher_Male.jpg"
                                    : item?.gender === "F"
                                      ? "/images/Teacher_Female.png"
                                      : "/images/default-profile.png"
                              }
                              alt="icon"
                              className="profilePicImg"
                              style={{
                                width: "23px",
                                height: "23px",
                                borderRadius: "50%",
                              }}
                              onError={(e) => {
                                if (item?.gender === "M") {
                                  e.target.src = "/images/Teacher_Male.jpg";
                                } else if (item?.gender === "F") {
                                  e.target.src = "/images/Teacher_Female.png";
                                } else {
                                  e.target.src = "/images/default-profile.png";
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="names_tacher">
                          <div>{item.label}</div>
                        </div>
                      </div>

                      <div>
                        <div className="mt-1">
                          {/* <Select
                            styles={DropdownStyle}
                            options={ClassOptions}
                            className=""
                            value={{
                              value: item.memberType,
                              label: capitalizeFirstLetter(item.memberType),
                            }}
                            onChange={(selectedOption) => {
                              handelChangePurticularMemberType(
                                selectedOption,
                                item.value
                              );
                            }}
                          /> */}
                          <FormControl size="small" fullWidth>
                            <Select
                              value={item.memberType || ""}
                              onChange={(e) => {
                                const selectedOption = ClassOptions.find(
                                  (opt) => opt.value === e.target.value
                                );
                                handelChangePurticularMemberType(
                                  selectedOption,
                                  item.value
                                );
                              }}
                              displayEmpty
                            >
                              {ClassOptions.map((option) => (
                                <MenuItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* student  */}
            <div className="mt-1">
              <div>
                {selectedStudentListClassState?.length > 0 && (
                  <div className="teacher_header" style={{ cursor: "pointer" }} onClick={() => setSelectedListStudentClassState([])}><spna>STUDENTS</spna>
                    <span> <X size={16} color="red" />{'Remove All'}</span>
                  </div>
                )}

                <div>
                  {selectedStudentListClassState.map((student) => {
                    return (
                      <div
                        key={student.id}
                        className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                      >
                        <div className="teachersNameImg d-flex justify-content-center">
                          <div className="NamesFirstLetter">
                            {student?.label?.substr(0, 1)}
                          </div>
                        </div>
                        <div className=" names_tacher">
                          {/* Display student info on UI */}
                          <div>
                            {student?.displayLevel} {" | " + student?.standard}{" "}
                            | {student?.section} |{" "}
                            {"Roll Code: " + student?.code}
                          </div>
                          <div>
                            <X size={20} style={{ cursor: "pointer" }} onClick={() => handleUnselectStudent(student?.value)} color="red" />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* GROUPS  */}
            <div className="mt-1">
              {addMember.addGroups && (
                <div>
                  <div className="teacher_header">GROUPS</div>

                  <div>
                    {selectedOptionsGoups.map((option) => (
                      <div
                        key={option.id}
                        className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                      >
                        <div className="teachersNameImg d-flex justify-content-center">
                          <div className="NamesFirstLetter">
                            {option.label.substr(0, 1)}
                          </div>
                        </div>
                        <div className="names_tacher">
                          <div>{option.label}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {console.log(
              "selectedStudentListClassState",
              selectedStudentListClassState
            )}

            {!isAddingModel ? (
              <div className="d-flex justify-content-between w-100 innerFlexContainer">
                <div className="d-flex gap-4">
                  <button
                    onClick={(e) => handleGoBack()}
                    className="Previous_Btn_channel"
                  >
                    Previous
                  </button>
                  {!inProgress ? (
                    <button
                      type="submit"
                      onClick={(e) => handelSubmit(e)}
                      className="btn btn-danger create_Btn"
                      disabled={
                        selectedOptions?.length === 0 &&
                        selectedStudentListClassState?.length === 0
                      }
                    >
                      Create
                    </button>
                  ) : (
                    <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
                  )}
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-end topMargin">
                <div className="d-flex gap-4 buttonsBox">
                  <button
                    onClick={(e) => {
                      setInAddingMode(!isAddingModel);
                      const fromdiscard = "Discard";
                      handleGoBack(fromdiscard);
                      setSelectedOptions([]);
                      localStorage.removeItem("TEACHER_OPTIONS_STORAGE_KEY");
                      setSelectedListStudentClassState([]);
                    }}
                    className="Previous_Btn_channel"
                  >
                    Discard
                  </button>
                  <button
                    type="submit"
                    disabled={isValid}
                    onClick={(e) => handelAddMemberInExisting(e)}
                    className="btn btn-danger create_Btn"
                  >
                    Save
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {showPopUp && (
          <CommunityPopup
            showErrorMsg={showErrorMsg}
            setShowPopUp={setShowPopUp}
          />
        )}
      </div>
    </>
  );
}
